import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useCart } from '@/context/CartContext';
import { Button } from '@/components/ui/button';
import { ShoppingCart, User, LogOut, LayoutDashboard } from 'lucide-react';

export const Header = () => {
  const { user, logout } = useAuth();
  const { getCartCount } = useCart();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getDashboardPath = () => {
    if (!user) return '/dashboard';
    if (user.role === 'admin') return '/admin/dashboard';
    if (user.role === 'doctor') return '/doctor/dashboard';
    if (user.role === 'corporate') return '/corporate/dashboard';
    if (user.role === 'wellness_center') return '/center/dashboard';
    return '/dashboard';
  };

  return (
    <header className="sticky top-0 z-50 w-full glass border-b border-gray-200" data-testid="main-header">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <div className="text-2xl font-bold text-primary" style={{ fontFamily: 'Playfair Display' }}>
              चिकित्साHub
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {user && (
              <>
                <Link to={getDashboardPath()} className="text-gray-700 hover:text-primary transition-colors" data-testid="dashboard-link">
                  Dashboard
                </Link>
                {user.role === 'user' && (
                  <>
                    <Link to="/doctors" className="text-gray-700 hover:text-primary transition-colors" data-testid="doctors-link">
                      Doctors
                    </Link>
                    <Link to="/products" className="text-gray-700 hover:text-primary transition-colors" data-testid="products-link">
                      Products
                    </Link>
                    <Link to="/treatments" className="text-gray-700 hover:text-primary transition-colors" data-testid="treatments-link">
                      Treatments
                    </Link>
                    <Link to="/subscriptions" className="text-gray-700 hover:text-primary transition-colors" data-testid="subscriptions-link">
                      Plans
                    </Link>
                    <Link to="/courses" className="text-gray-700 hover:text-primary transition-colors" data-testid="courses-link">
                      Courses
                    </Link>
                    <Link to="/yoga" className="text-gray-700 hover:text-primary transition-colors" data-testid="yoga-link">
                      Yoga
                    </Link>
                    <Link to="/blogs" className="text-gray-700 hover:text-primary transition-colors" data-testid="blogs-link">
                      Blogs
                    </Link>
                    <Link to="/ai-assistant" className="text-gray-700 hover:text-primary transition-colors" data-testid="ai-assistant-link">
                      AI Assistant
                    </Link>
                  </>
                )}
              </>
            )}
          </nav>

          <div className="flex items-center space-x-4">
            {user ? (
              <>
                {user.role === 'user' && (
                  <Link to="/cart" className="relative" data-testid="cart-button">
                    <Button variant="ghost" size="icon" className="relative">
                      <ShoppingCart className="h-5 w-5" />
                      {getCartCount() > 0 && (
                        <span className="absolute -top-1 -right-1 bg-secondary text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                          {getCartCount()}
                        </span>
                      )}
                    </Button>
                  </Link>
                )}
                <Button
                  variant="ghost"
                  onClick={handleLogout}
                  className="flex items-center space-x-2"
                  data-testid="logout-button"
                >
                  <LogOut className="h-4 w-4" />
                  <span>Logout</span>
                </Button>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;